import VFX_ACCELERATION from '../../../assets/levels/vfx/acceleration.png'
import VFX_GLOW from '../../../assets/levels/vfx/glow.png'
import VFX_RAY from '../../../assets/levels/vfx/ray.png';
import SNOW_PARTICLE from '../../../assets/snow_particle.png';
import SNOW_ROAD from '../../../assets/levels/snow.png';
import BACKGROUND_SKY_IMG from '../../../assets/levels/pack1/background_sky.png';
import BACKGROUND_MOUNTAINS_IMG from '../../../assets/levels/pack1/background_mountains.png';
import BACKGROUND_CLOUDS_1_IMG from '../../../assets/levels/pack1/background_clouds_1.png';
import BACKGROUND_SUN_IMG from '../../../assets/levels/pack1/background_sun.png';
import BACKGROUND_CLOUDS_2_IMG from '../../../assets/levels/pack1/background_clouds_2.png';
import BACKGROUND_FOREST_IMG from '../../../assets/levels/pack1/background_forest.png';
import BACKGROUND_CITY_1_IMG from '../../../assets/levels/pack1/background_city_1.png';
import BACKGROUND_CITY_2_IMG from '../../../assets/levels/pack1/background_city_2.png';
import BACKGROUND_HORIZON_IMG from '../../../assets/levels/pack1/background_horizon.png';
import BACKGROUND_GRADIENT_IMG from '../../../assets/levels/pack1/background_gradient.png';
import BACKGROUND_ROAD_CENTER_IMG from '../../../assets/levels/pack1/background_road_center.png';
import BACKGROUND_ROAD_IMG from '../../../assets/levels/pack1/background_road.jpg';
import BACKGROUND_LINE_IMG from '../../../assets/levels/pack1/background_line.png';

import LVL2_BACKGROUND_SKY_IMG from '../../../assets/levels/pack2/background_sky.png';
import LVL2_BACKGROUND_MOUNTAINS_IMG from '../../../assets/levels/pack2/background_mountains.png';
import LVL2_BACKGROUND_SUN_IMG from '../../../assets/levels/pack2/background_stars.png';
import LVL2_BACKGROUND_FOREST_IMG from '../../../assets/levels/pack2/background_forest.png';
import LVL2_BACKGROUND_CITY_1_IMG from '../../../assets/levels/pack2/background_city_1.png';
import LVL2_BACKGROUND_CITY_2_IMG from '../../../assets/levels/pack2/background_city_2.png';
import LVL2_BACKGROUND_HORIZON_IMG from '../../../assets/levels/pack2/background_horizon.png';
import LVL2_BACKGROUND_GRADIENT_IMG from '../../../assets/levels/pack2/background_gradient.png';
import LVL2_BACKGROUND_ROAD_CENTER_IMG from '../../../assets/levels/pack2/background_road_center.png';
import LVL2_BACKGROUND_ROAD_IMG from '../../../assets/levels/pack2/background_road.png';
import LVL2_BACKGROUND_LINE_IMG from '../../../assets/levels/pack2/background_line.png';
import COIN from '../../../assets/coin.png';
import COIN56 from '../../../assets/coin56.png';
import COIN64 from '../../../assets/coin64.png';
import COIN70 from '../../../assets/coin70.png';

export {
    VFX_ACCELERATION,
    VFX_RAY,
    VFX_GLOW,
    BACKGROUND_SKY_IMG,
    BACKGROUND_MOUNTAINS_IMG,
    BACKGROUND_CLOUDS_1_IMG,
    BACKGROUND_SUN_IMG,
    BACKGROUND_CLOUDS_2_IMG,
    BACKGROUND_FOREST_IMG,
    BACKGROUND_CITY_1_IMG,
    BACKGROUND_CITY_2_IMG,
    BACKGROUND_HORIZON_IMG,
    BACKGROUND_GRADIENT_IMG,
    BACKGROUND_ROAD_CENTER_IMG,
    BACKGROUND_ROAD_IMG,
    BACKGROUND_LINE_IMG,
    LVL2_BACKGROUND_SKY_IMG,
    LVL2_BACKGROUND_MOUNTAINS_IMG,
    LVL2_BACKGROUND_FOREST_IMG,
    LVL2_BACKGROUND_SUN_IMG,
    LVL2_BACKGROUND_CITY_1_IMG,
    LVL2_BACKGROUND_CITY_2_IMG,
    LVL2_BACKGROUND_HORIZON_IMG,
    LVL2_BACKGROUND_GRADIENT_IMG,
    LVL2_BACKGROUND_ROAD_CENTER_IMG,
    LVL2_BACKGROUND_ROAD_IMG,
    LVL2_BACKGROUND_LINE_IMG,
    COIN,
    COIN56,
    COIN64,
    COIN70,
    SNOW_PARTICLE,
    SNOW_ROAD,
}

export interface IHighway {
    backgroundSky: any;
    backgroundClouds: any[];
    backgroundMountains: any[];
    backgroundSun: any;
    backgroundCity: any[];
    backgroundForest: any;
    backgroundRoad: any;
    roadGradient: any;
    horizon: any;

}

export const Level1: IHighway = {
    backgroundSky: BACKGROUND_SKY_IMG,
    backgroundClouds: [
        BACKGROUND_CLOUDS_1_IMG,
        BACKGROUND_CLOUDS_2_IMG,
    ],
    backgroundMountains: [
        BACKGROUND_MOUNTAINS_IMG,
    ],
    backgroundCity: [
        BACKGROUND_CITY_1_IMG,
        BACKGROUND_CITY_2_IMG,
    ],
    backgroundForest: BACKGROUND_FOREST_IMG,
    backgroundRoad: BACKGROUND_ROAD_IMG,
    roadGradient: BACKGROUND_GRADIENT_IMG,
    horizon: BACKGROUND_HORIZON_IMG,
} as IHighway;

export const Level2: IHighway = {
    backgroundSky: LVL2_BACKGROUND_SKY_IMG,
    backgroundClouds: [
    ],
    backgroundMountains: [
        LVL2_BACKGROUND_MOUNTAINS_IMG,

    ],
    backgroundCity: [
        LVL2_BACKGROUND_CITY_1_IMG,
        LVL2_BACKGROUND_CITY_2_IMG,
    ],
    backgroundForest: LVL2_BACKGROUND_FOREST_IMG,
    backgroundRoad: LVL2_BACKGROUND_ROAD_IMG,
    roadGradient: LVL2_BACKGROUND_GRADIENT_IMG,
    horizon: LVL2_BACKGROUND_HORIZON_IMG,
} as IHighway;
